export default __webpack_public_path__ + "static/media/bg-profile.af1219a7.jpeg";